import { lazy } from 'react';

export const LazyDatepicker = lazy(() => import('./Datepicker'));
